import tailwindConfig from 'tailwind.config';

import { regions } from '../constants/regions';
import { useMediaQuery } from '../hooks/useMediaQuery';
import { MainLinkItem, MainLinkItemProps } from './MainLinkItem';
import { MenuUnderlay } from './MenuUnderlay';

import IconGlobe from '~/icons/globe-02.svg';

export type MainLinksProps = {
  links: MainLinkItemProps['link'][];
  activeLinkTitle: string;
  hoveredLinkTitle: string;
  isRegionVisible: boolean;
  onLinkClick?: (
    params: { title: string } | { url: string; keepMenuOpen?: boolean }
  ) => void;
  onLinkHover: (title?: string) => void;
  onLinkHoverCancel: (title?: string) => void;
};

export function MainLinks({
  links,
  activeLinkTitle,
  onLinkClick,
  hoveredLinkTitle,
  onLinkHover,
  onLinkHoverCancel,
  isRegionVisible,
}: MainLinksProps) {
  const isWidthBelowXL = useMediaQuery(
    `(max-width: ${parseInt(tailwindConfig.theme.screens.headerLg) - 1}px)`,
    (matches) =>
      !matches &&
      onLinkClick?.({
        title: '',
      })
  );

  const updatedLinks =
    isWidthBelowXL && isRegionVisible
      ? enrichMainLinksWithRegion(links)
      : links;

  const handleMenuSheetClose = () => {
    onLinkClick?.({ title: '' });
    onLinkHoverCancel();
  };

  return (
    <>
      <ul className='headerLg:flex-row headerLg:items-center headerLg:gap-x-2 z-10 row-span-full flex flex-col self-stretch overflow-y-auto overflow-x-clip'>
        {updatedLinks.map((link) => (
          <MainLinkItem
            key={link.item.title}
            link={link}
            isActive={activeLinkTitle === link.item.title}
            isHovering={
              !!hoveredLinkTitle ? hoveredLinkTitle !== link.item.title : false
            }
            onLinkClick={onLinkClick}
            onLinkHover={onLinkHover}
            onLinkHoverCancel={onLinkHoverCancel}
          />
        ))}
      </ul>

      {!!activeLinkTitle && <MenuUnderlay onClick={handleMenuSheetClose} />}
    </>
  );
}

const enrichMainLinksWithRegion = (links: MainLinksProps['links']) => {
  const regionLink = {
    item: {
      title: 'Region',
      icon: <IconGlobe />,
    },
    menu: [
      {
        lists: [
          {
            title: 'Region',
            items: regions.map((region) => ({
              title: region.title,
              url: region.href,
            })),
          },
        ],
      },
    ],
  } satisfies MainLinkItemProps['link'];

  return links.concat(regionLink);
};
